'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var material = require('@mui/material');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Skeleton = function (_a) {
    var className = _a.className, _b = _a.variant, variant = _b === void 0 ? constants_properties.SkeletonVariant.TEXT : _b, width = _a.width, height = _a.height;
    return (React__default["default"].createElement(material.Skeleton, { className: className, width: width, height: height, variant: variant }));
};

exports["default"] = Skeleton;
